<template>
	<div class="relation-media-container">
		<v-alert v-model="showAlert" text v-if="auth.is_multi_user_company" class="ma-auto" dismissible dense type="info"
			style="width:50%;z-index: 99999"
		>
			<strong>
				שימו &#10084;
			</strong>
			-
			הנכם מחוברים למנוי קבוצתי. כל תמונה, מדיה ושאלה שתעלה תהיה משותפת עם שאר היוצרים בקבוצה.
		</v-alert>
		<v-btn fab class="close-button" v-if="showCloseBtn" small color="primary" @click="$emit('close')">
			<v-icon>mdi-close</v-icon>
		</v-btn>
		<message-iframe :class="{'mt-4':showAlert&&auth.is_multi_user_company}" slot="content" fullscreen :src="mediaLink"
			@message="onGetMessage" @load="showCloseBtn=true"
		/>
	</div>
</template>

<script>
import MessageIframe from "dev/components/MessageIframe";
import media from "dev/config/media";
import { mapGetters } from "vuex";

export default {
	name: "relation-media-modal",
	props: ["selectedMedia", "typeFilter", "value"],
	components: {
		MessageIframe
	},
	data() {
		return {
			showCloseBtn: false,
			showAlert: true,
		};
	},
	computed: {
		...mapGetters([
			"isCompany",
		]),
		auth() {
			return this.$store.state.AuthModule.user;
		},
		baseUrl() {
			return media.baseUrl;
		},
		token() {
			return this.$store.state.AuthModule.user.token;
		},
		mediaLink() {
			let link = this.baseUrl + "?token=" + this.token;
			if (this.typeFilter.length === 1) {
				let media =
					this.typeFilter[0] === "sound" ? "audio" : this.typeFilter[0];
				link += `&media=${media}`;
			}
			return link;
		},
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		copy(link) {
			this.$emit("mediaSelected", { link });
			this.$emit("close");
		},
		onGetMessage(action) {
			if (typeof this[action.action] === "function") {
				this[action.action](action.data);
			}
		},
		mediaSelected(link) {
			this.$emit("mediaSelected", link);
			this.$emit("close");
		}
	}
};
</script>

<style scoped lang="scss">
.relation-media-container{
  position: fixed;
  top:0;
  right:0;
  bottom:0;
  left:0;
  z-index: 4;

  .close-button{
    position: fixed;
    top:20px;
    right:10px;
    z-index: 10001;
  }
}
</style>
